var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoReviews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20V2C0 0.9 0.9 0.01 2 0.01L12 0C13.1 0 14 0.9 14 2V6H12V5H2V17H12V16H14V20C14 21.1 13.1 22 12 22H2C0.9 22 0 21.1 0 20ZM12 20V19H2V20H12ZM2 2H12V3H2V2ZM17.2 8.55L15.8 7.15L10.75 12.2L8.4 9.85L7 11.25L10.75 15L17.2 8.55Z",
    fill: "#545F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoReviews);
export default __webpack_public_path__ + "static/media/icon-no-reviews.63051081cf49828a20fc48affbee562e.svg";
export { ForwardRef as ReactComponent };